// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT!
    /* tslint:disable */
    export const VERSION = '2.0.607';
    /* tslint:enable */